// Language detection for the iframe-embedded simulator.
//
// GTranslate on neweyesparis.com produces URLs like:
//   FR (default): https://neweyesparis.com/simulateur-couleurs-keratopigmentation/
//   EN:           https://neweyesparis.com/en/simulateur-couleurs-keratopigmentation/
//   DE:           https://neweyesparis.com/de/...
//   IT:           https://neweyesparis.com/it/...
//   ZH-CN:        https://neweyesparis.com/zh-CN/...
// The iframe src is identical across versions, so we read the parent page URL
// via document.referrer to pick the right language.

const SUPPORTED_SHORT_CODES = ["fr", "en", "de", "it", "es"];
const REFERRER_LANG_PREFIX = /^\/(en|de|it|es|zh-CN)\//;

export function detectLanguage() {
  if (typeof window === "undefined") return "fr";

  console.log("[lang] detectLanguage() start", {
    href: window.location.href,
    referrer: document.referrer,
    navigatorLanguage: navigator.language,
    navigatorLanguages: navigator.languages,
    ancestorOrigins: window.location.ancestorOrigins
      ? Array.from(window.location.ancestorOrigins)
      : "unsupported",
  });

  // 1. Explicit ?language= query param wins (manual override, dev/testing).
  const queryLang = new URLSearchParams(window.location.search).get("language");
  if (queryLang) {
    console.log("[lang] → query param:", queryLang);
    return queryLang;
  }

  // 2. Read GTranslate language segment from the parent page URL.
  if (document.referrer) {
    try {
      const referrerUrl = new URL(document.referrer);
      console.log("[lang] referrer parsed:", {
        hostname: referrerUrl.hostname,
        pathname: referrerUrl.pathname,
      });
      const match = referrerUrl.pathname.match(REFERRER_LANG_PREFIX);
      if (match) {
        console.log("[lang] → referrer path prefix:", match[1]);
        return match[1];
      }
      if (referrerUrl.hostname.includes("neweyesparis")) {
        console.log("[lang] → neweyesparis hostname, no path prefix, defaulting to fr");
        return "fr";
      }
      console.log("[lang] referrer matched no rule, falling through");
    } catch (e) {
      console.log("[lang] referrer parse failed", e);
    }
  } else {
    console.log("[lang] no document.referrer");
  }

  // 3. navigator.language fallback when referrer is unavailable.
  const navLang = (navigator.language || "").toLowerCase();
  if (navLang.startsWith("zh")) {
    console.log("[lang] → navigator zh:", navLang);
    return "zh-CN";
  }
  const short = navLang.slice(0, 2);
  if (SUPPORTED_SHORT_CODES.includes(short)) {
    console.log("[lang] → navigator short:", short);
    return short;
  }

  // 4. Default.
  console.log("[lang] → default fr");
  return "fr";
}

export function getCountryForLanguage(language) {
  switch (language) {
    case "fr": return "France";
    case "de": return "Germany";
    case "it": return "Italy";
    case "es": return "Spain";
    case "en": return "United States of America (the)";
    case "zh-CN": return "China";
    default: return null;
  }
}
